import { render, staticRenderFns } from "./AiExercisePadPlan.vue?vue&type=template&id=32cd6a3c&scoped=true"
import script from "./AiExercisePadPlan.vue?vue&type=script&lang=js"
export * from "./AiExercisePadPlan.vue?vue&type=script&lang=js"
import style0 from "./AiExercisePadPlan.vue?vue&type=style&index=0&id=32cd6a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cd6a3c",
  null
  
)

export default component.exports